import { OnInit, AfterViewInit, Component, TemplateRef, ViewChild, ViewContainerRef, ElementRef, Injector, signal, ChangeDetectorRef } from '@angular/core';

import { Layer } from '../../models/layer';
import { LayerService } from '../../services/layers/layer.service';
import { AnimationEvent, trigger, state, style, animate, transition } from '@angular/animations';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, DomPortal, Portal, TemplatePortal } from '@angular/cdk/portal';

import { PopupService } from '../../services/popup.service';
import { MarkerService } from '../../services/marker.service';
import { MapService } from '../../services/map.service';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { OlLayerService } from '../../services/ol/ol-layer.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tt-base-layer-selector',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatListModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatGridListModule,
    MatSnackBarModule,
    MatDialogModule,
    TranslateModule,
    MatTabsModule,
    CommonModule,
    FormsModule,
    // PopoverComponent
  ],
  templateUrl: './base-layer-selector.component.html',
  styleUrls: ['./base-layer-selector.component.scss'],
  animations: [
    trigger('openClose', [
      state('close', style({
        opacity: 0.0,
        transform: 'scale(0.8)'
      })),
      state('open', style({
        opacity: 1.0,
        transform: 'scale(1.0)'
      })),
      transition('open => close', [
        animate('0.1s cubic-bezier(0.0, 0.0, 0.2, 1)')
      ]),
      transition('close => open', [
        //animate('0.2s cubic-bezier(0.4, 0.0, 0.2, 1)'),
        animate('0.2s cubic-bezier(0.0, 0.0, 0.2, 1)')
      ]),
    ]),
  ],
  standalone: true
})
export class BaseLayerSelectorComponent implements OnInit {
  //ng-template ref
  @ViewChild('baselayerPanel') baselayerPanel: TemplateRef<unknown>;
  protected overlayRef: OverlayRef;
  protected isAnimating: boolean;
  isOpen = signal(false);
  // isRendered = false;
  selectedBaselayer: Layer;
  protected subscriptions: Subscription = new Subscription();

  constructor(
    public layerService: LayerService,
    protected overlay: Overlay,
    protected _viewContainerRef: ViewContainerRef,
    protected _elementRef: ElementRef<HTMLElement>,

    injector: Injector,
    public popup: PopupService,
    public markerService: MarkerService,
    public mapService: MapService,
    protected cdr: ChangeDetectorRef
  ) {

    // this is nescessary when working with custom elements
    // const PopupElement = createCustomElement(PopupComponent, { injector });
    // Register the custom element with the browser.
    // customElements.define('popup-element', PopupElement);

  }
  map;
  private mapClickSubscription: Subscription;

  ngOnInit() {
    this.layerService.getSelectedBaselayer$().subscribe((layer) => {
      this.selectedBaselayer = layer;
      this.cdr.markForCheck();
    });

    this.map = this.mapService.getMap();
  }


  // //popup test
  // displayPopup(feature: Feature) {
  //   let point: Point = <Point>feature.getGeometry();
  //   var popupProperties = {
  //     coordinates: point.getCoordinates(),
  //     type: feature.get('type'),
  //     title: "A title",
  //     // bigTitle: "Big title",
  //     content: '<span style="color:yellow"> Objects in <em>popup</em> are closer than they appear.</span>',
  //     zoomToFeatureLink: true,
  //     customEvent: {
  //       eventId: 'doSomethingEvent',
  //       label: 'do something',
  //       data: feature
  //     },
  //     className: 'sjappi'
  //   }
  //   this.popup.add(
  //     popupProperties
  //   )
  // }
  // //popup test
  // customEventHandler(obj) {
  //   alert('joehoew 😃: ' + obj.detail.eventId)
  // }

  // counter: number = 0;
  // addmarker(styleClass) {
  //   let x: number = 594121.50 + this.counter * 100
  //   let feature: Feature = new Feature({
  //     geometry: new Point([x, 6619543.20]),
  //     //labelPoint: new Point(labelCoords),
  //     name: 'Sjappi',
  //     type: 'sjappi',
  //   });
  //   feature.set('styleClass', styleClass);

  //   if (this.counter === 4) {
  //     feature.set('highlight', true);
  //     this.displayPopup(feature);
  //   }
  //   this.markerService.add(feature);
  // }

  ngAfterViewInit() {
    // add some markers for testing...
    // let markerStyles = ['street', 'address', 'toponym', 'coords', 'featureInfo', 'coords', 'defaultFilled', 'default'];
    // for (this.counter; this.counter < 10; this.counter++) {
    //   this.addmarker(markerStyles[this.counter]);
    // }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  close() {
    this.isOpen.set(false);
  }

  open() {
    // if (this.isAnimating) {
    //   return;
    // }

    if (!this.overlayRef) {
      this.overlayRef = this.createOverlay();
      this.subscriptions.add(this.overlayRef.backdropClick().subscribe(_ => {
        this.close()
      }));
    }
    // console.dir(this.subscriptions);
    const baseLayerSelectorPortal = new TemplatePortal(this.baselayerPanel, this._viewContainerRef);
    this.overlayRef.attach(baseLayerSelectorPortal)
    this.isOpen.set(true);
  }

  onAnimationEventStart(event: AnimationEvent) {
    this.isAnimating = true;
  }

  onAnimationEventEnd(event: AnimationEvent) {
    this.isAnimating = false;
    if (event.fromState === 'open' && event.phaseName === 'done') {
      this.overlayRef.detach();
      //this.overlayRef.dispose();
    }
  }

  protected createOverlay(): OverlayRef {
    if (this.overlayRef) {
      return this.overlayRef;
    }
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(this._elementRef)
      .withPositions([{
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom'
      }])
      // .withTransformOriginOn('.baselayer-panel')
      .withFlexibleDimensions(true)
    //.withViewportMargin(8)
    //.withScrollableContainers(scrollableAncestors);

    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: '',
      positionStrategy: positionStrategy,
      // panelClass: '',
      // scrollStrategy: this._scrollStrategy()
    });
    return this.overlayRef;
  }

  switchBaseLayer(layerId: string) {
    let currentLayer: Layer = this.layerService.getBaseLayers().find((layer) => layer.id === layerId);
    this.layerService.showSelectedBaselayer(currentLayer);
  }

  getClassName(name) {
    //replace dots by tiret
    return name.replace(/\./g, "-");
  };

  getClass = function (layer) {
    let cssClass = this.getClassName(layer.id);
    cssClass += (layer.id === this.selectedBaselayer.id) ? ' selected' : '';
    return cssClass;
  };
}
